import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import TextArea from "@/common/components/TextArea";
import { lastReviewSchema, LastReviewValidationSchema } from "@/common/schemas/lastReview.schema";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useUpdateMaintenanceDirectiveDiagnosticEntryLastReview } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/directive/diagnosticEntries/useUpdateMaintenanceDirectiveDiagnosticEntryLastReview";
import { useForwardingTabContext } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/useForwardingTabContext";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

const DirectiveEntryDiagnosticEntriesDisapprove = () => {
  const { forwarding } = useForwardingTabContext();

  const { id } = useParams();

  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: {
      errors,
    },
  } = useForm<LastReviewValidationSchema>({
    resolver: zodResolver(lastReviewSchema),
    defaultValues: {
      state: 'disapproved',
    },
  });

  const {
    mutate: updateLastReview,
    isPending: updateLastReviewIsPending,
  } = useUpdateMaintenanceDirectiveDiagnosticEntryLastReview({
    directiveEntryId: forwarding?.directive_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        });

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        });

        setIsOpen(false);
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setError,
          setMessages,
        })(error);
      }
    }
  });

  const onSubmit: SubmitHandler<LastReviewValidationSchema> = (data) => updateLastReview(data);

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="yellow"
            operationKlassToCheckPermission="Admin::Maintenance::Directive::DiagnosticEntries::Update"
          >
            Declinar
          </Button>
        )}
        title="Reprovar diagnóstico"
        useCancellableFooter
        cancelButtonClassName="bg-white-100"
        confirmButtonClassName="bg-primary-blue"
        onConfirm={handleSubmit(onSubmit)}
        confirmButtonIsLoading={updateLastReviewIsPending}
        bodyClassName="text-white-800"
        body={(
          <div className="flex flex-col gap-2">
            <p className="text-base font-semibold">
              Detalhe o motivo da sua reprovação
            </p>

            <TextArea
              label="Mensagem de reprovação"
              markAsRequired
              rows={4}
              placeholder="Escreva aqui sua justificativa"
              {...register('description')}
              errorMessage={errors.description?.message}
            />
          </div>
        )}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DirectiveEntryDiagnosticEntriesDisapprove;
